// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"a574046e","514":"9515a939","617":"808e506f","718":"2b6bbee5","744":"12548007","911":"f4392ade"}[chunkId] + ".chunk.js";
};